import { styled } from '@uhg-abyss/web/tools/styled';
import { Drawer } from '@uhg-abyss/web/ui/Drawer';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { ModalDialog } from '@uhg-abyss/web/ui/ModalDialog';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';

export const DrawerHeading = {
  '&.abyss-heading-root': {
    '@media (max-width: 464px)': {
      fontSize: '$xl',
    },
  },
};

export const StyledDrawer = styled(Drawer, {
  dynamic: ({ cssProps: { mapViewEnhancement } = {} }) => ({
    [`@media screen and (width < ${
      mapViewEnhancement ? 372 : 232
    }px) and (orientation: portrait),
       screen and (width < 865px) and (orientation: landscape)`]: {
      '.abyss-modal-base-content-container': {
        top: '0px',
        overflowX: 'hidden',
        overflowY: 'auto',
      },
      '.abyss-modal-base-body': {
        overflow: 'initial',
      },
    },
  }),

  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    width: '408px',
    '@media (max-width: 744px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '.abyss-modal-close-button': {
    '@media (max-width: 744px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-content-title': {
    color: '$core.color.neutral.90',
    fontFamily: '$primary',
    fontWeight: 'bold',
    fontSize: '20.25px',
    lineHeight: '24px',
  },
  '.abyss-modal-base-body': {
    scrollbarWidth: 'none' /* Hide scrollbar for Chrome, Safari and Opera */,
    '::-webkit-scrollbar': {
      display: 'none',
    },
    paddingRight: 0,
    paddingLeft: 0,
    paddingTop: 0,
    rowGap: 0,
  },
});

export const StyledModal = styled(ModalDialog, {
  dynamic: ({ cssProps: { mobileScreen } = {} }) => ({
    '.abyss-modal-base-content-container': {
      top: mobileScreen ? '0px' : '25px',
    },
  }),
  zIndex: '999 !important',
  '.abyss-modal-header-container': {
    width: 'fit-content',
  },
  '.abyss-modal-base-content-container': {
    borderRadius: 0,
    width: '408px',
    '@media (max-width: 464px)': {
      top: '25px',
      height: 'calc(100vh - 26px)',
      width: '100%',
      borderRadius: '20px 20px 0px 0px',
      color: '$core.color.brand.100',
      border: '1px solid $core.color.brand.100',
    },
  },
  '.abyss-modal-close-button': {
    '@media (max-width: 464px)': {
      top: '12px',
      right: '12px',
    },
  },
  '.abyss-modal-content-title': {
    color: '$core.color.neutral.90',
    fontFamily: '$primary',
    fontWeight: 'bold',
    fontSize: '20.25px',
    lineHeight: '24px',
  },
  '.abyss-modal-base-body': {
    scrollbarColor: 'transparent transparent' /* Hide scrollbar for Firefox */,
    '&.hideScrollBar::-webkit-scrollbar': {
      display: 'contents' /* Hide scrollbar for Chrome, Safari and Opera */,
    },
    paddingRight: 0,
    paddingLeft: 0,
  },
});

export const FilterWrapper = styled(Flex, {
  flexDirection: 'column',
  flexWrap: 'nowrap',
  height: '100vh',
  scrollbarColor: 'transparent transparent' /* Hide scrollbar for Firefox */,
  '&.hideScrollBar::-webkit-scrollbar': {
    display: 'contents' /* Hide scrollbar for Chrome, Safari and Opera */,
  },
  '@media (max-width: 464px)': {
    marginBottom: '70px',
    height: 'calc(100vh - 30px)',
  },
});

export const ScrollableSection = styled(Flex, {
  '&.abyss-flex-root': {
    overflowY: 'auto',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    width: '104%',
    '&.abyss-search-input-root': {
      height: 'auto',
    },
    '@media (max-width: 464px)': {
      width: '100%',
    },
  },
});

export const StyledSearchInput = styled(TextInput, {
  '.abyss-text-input-label': {
    fontSize: '$md',
    fontWeight: '$medium',
    lineHeight: '20px',
    marginBottom: '14px',
  },
  '.abyss-text-input': {
    padding: '$sm 30px $sm 40px',
    fontSize: '$md',
    color: '$core.color.neutral.90',
    fontWeight: '600',
    lineHeight: '24px',
    borderRadius: '100px',
    '&::placeholder': {
      fontWeight: '$medium',
      color: '#6E7072',
      fontStyle: 'italic',
    },
  },
  '.abyss-text-input-left-element': {
    minWidth: 'auto',
    marginLeft: '12px',
    '.abyss-icon-symbol': {
      fill: '#19191A',
      height: '24px',
      width: '24px',
    },
  },
});
